/**
   * セールステータスを取得する関数
   * @returns {string} 'sale' | 'pre_sale' | 'post_sale'
   */
const getSaleTimeStatus = (target) => {
  
    const now = new Date()
    const saleStart = new Date(target.getAttribute('data-sale-start'))
    const saleEnd = new Date(target.getAttribute('data-sale-end'))
    
    // Invalid Dateを検出（メタフィールドが空の場合、new Date('')はInvalid Dateを返す）
  if (isNaN(saleStart.getTime()) && isNaN(saleEnd.getTime())) {
      return 'timeNotSet'
    }
  if (now < saleStart && isNaN(saleEnd.getTime())) {
      return 'preSale'
    }
  if (now >= saleStart && isNaN(saleEnd.getTime())) {
      return 'sale'
    }
  if (isNaN(saleStart.getTime()) && now <= saleEnd) {
      return 'sale'
    }
  if (isNaN(saleStart.getTime()) && now > saleEnd) {
      return 'postSale'
    }
  if (now < saleStart) {
      return 'preSale'
    }
  else if (now >= saleStart && now <= saleEnd) {
      return 'sale'
    }
  else if (now > saleEnd) {
      return 'postSale'
    }
    
  }